module.exports = __webpack_public_path__ + "static/media/bg.dd28c4c9.png";